export default __webpack_public_path__ + "static/media/060663018034-web-tete.4ef9bad4.svg";